module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoT.4a88613.woff";